/**
 * Styled component used for download/copy button shown on asset thumbnails
 */

import styled, { withTheme } from "styled-components";
import { Asset, AssetType, Button } from "@thenounproject/lingo-core";

type Props = {
  icon?: string;
  buttonPosition?: "center" | "bottom";
};

export const AssetActionButton = styled(Button).attrs<Props>(props => {
  return {
    icon: props.icon || "download",
    size: "small",
    className: "action-button",
    themeOverrides: {
      primaryColor: "rgba(42, 42, 42, 0.7)",
      primaryColorDark: "black",
      primaryColorTint: "white",
    },
    position: props.position ?? "absolute",
    bottom: props.buttonPosition === "center" ? "50%" : "4px",
    transform: props.buttonPosition === "center" ? "translateY(50%)" : null,
    right: props.buttonPosition === "center" ? "s" : "4px",
  };
})<Props>`
  opacity: 0;
  line-height: 0;
  box-shadow: 0 1px 3px 0 rgba(36, 36, 37, 0.12) !important;
`;

export default withTheme(AssetActionButton);

export function getUseIcon(asset: Asset): string {
  switch (asset.type) {
    case AssetType.color:
      return "action.copy";
    case AssetType.URL:
      return "action.external-link";
    default:
      return "action.download";
  }
}
